import socketManager from './socketManager'

export const sendClearSessionEvent = () => {
  localStorage.clear()
  socketManager.emitSignal('clear_storage', {})
  window.location.reload()
}
